<sms-dialog [title]="'Reset Password'" [size]="'sm'" (close)="close()">
  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" body>
    <div class="paddindSpace">
      <div class="filter-inputs">

          <!-- Password Field -->
          <div class="row rowAllSpaceMain">
            <div class="col-md-12 spaceDivBottom mainAllSpace">
              <label class="form-label">Password<span class="required">*</span></label>
              <div class="resetBtnMain">
              <input [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="New Password"
                formControlName="password" required />
              <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"
                (click)="togglePasswordVisibility('password')"></i>
                </div>

              <div class="errorBlk" *ngIf="resetForm.get('password')?.invalid && resetForm.get('password')?.touched">
                <small *ngIf="resetForm.get('password')?.errors?.['required']" class="errorsmall">
                  Password is required
                </small>
                <small *ngIf="!resetForm.get('password')?.errors?.['required'] && (resetForm.get('password')?.errors?.['minlength'] || resetForm.get('password')?.errors?.['pattern'])" class="errorsmall">
                  Password must be at least 8 characters and include an uppercase letter, lowercase letter, number, and special character.
                </small>
              </div>
            </div>


            <!-- Confirm Password Field -->
            <div class="col-md-12 spaceDivBottom mainAllSpace">
              <label class="form-label">Confirm Password<span class="required">*</span></label>
              <div class="resetBtnMain">
                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                  placeholder="Re-enter New Password" formControlName="confirmPassword" required />
                <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye' : 'bi-eye-slash'"
                  (click)="togglePasswordVisibility('confirmPassword')"></i>
              </div>

              <div class="errorBlk"
                *ngIf="resetForm.get('confirmPassword')?.touched">

              <small class="errorsmall"
                    *ngIf="resetForm.get('confirmPassword')?.errors?.['required']">
                Confirm Password is required
              </small>

              <small class="errorsmall"
                    *ngIf="!resetForm.get('confirmPassword')?.errors?.['required']
                          && resetForm.errors?.['passwordMismatch']">
                Passwords do not match
              </small>

            </div>
            </div>
          </div>

      </div>
    </div>
  </form>
  <ng-container footer>
    <button type="button" class="secondary-btn" (click)="resetFormFields()">Reset</button>
    <button type="button" class="primary-button" [disabled]="resetForm.invalid" (click)="onSubmit()">Save</button>
  </ng-container>
</sms-dialog>
